/**
 * Demo-mode banner (rev 12).
 *
 * The point of this component is to make it impossible to mistake a demo
 * build for a real deployment. If the login screen is bypassed, something must
 * be visibly, persistently wrong-looking.
 *
 * It states three facts:
 *   1. authentication is DISABLED for this build;
 *   2. the data shown is synthetic, not patient data;
 *   3. the API still enforces its own deny-by-default guard.
 */
import { isDemoSession, DEMO_USER } from "@/lib/demo-mode";

export function DemoBanner() {
  if (!isDemoSession()) return null;
  return (
    <div
      role="status"
      data-testid="demo-banner"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: "#7c2d12",
        color: "#fff7ed",
        fontSize: 12,
        lineHeight: 1.35,
        padding: "6px 12px",
        textAlign: "center",
        fontWeight: 600,
        letterSpacing: "0.01em",
        borderBottom: "2px solid #fb923c",
      }}
    >
      MODE DÉMO — authentification désactivée. Session synthétique
      {DEMO_USER.tenantName ? ` (${DEMO_USER.tenantName})` : ""}. Aucune donnée
      patient réelle. L&apos;API conserve son contrôle d&apos;accès.
    </div>
  );
}
